import { Component } from '@angular/core';
import { ProfileNavStateService } from '../profile-nav-state.service';

@Component({
    selector: 'app-profile-header',
    templateUrl: './profile-header.component.html',
    styleUrls: ['./profile-header.component.scss'],
    standalone: false
})
export class ProfileHeaderComponent {

  constructor(public readonly profileNavState: ProfileNavStateService) { }

  toggleMenu(): void {
    this.profileNavState.toggle();
  }
}
